import Button from "@intility/bifrost-react/Button";
import Grid from "@intility/bifrost-react/Grid";
import Input from "@intility/bifrost-react/Input";
import Message from "@intility/bifrost-react/Message";
import Section from "@intility/bifrost-react/Section";
import { useState } from "react";
import { checkRelationship } from "~/api/client";
import { PageLayout } from "~/components/layout/PageLayout";

export default function RelationshipCheck() {
  const [user, setUser] = useState("");
  const [relation, setRelation] = useState("");
  const [object, setObject] = useState("");
  const [result, setResult] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const doCheck = () => {
    if (!user || !relation || !object) return;
    setLoading(true);
    setError(null);
    setResult(null);

    checkRelationship({
      tupleKey: { user, relation, object },
    })
      .then((res) => setResult(res.allowed))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  return (
    <PageLayout
      breadcrumbs={[
        { label: "Home", to: "/" },
        { label: "Authorization" },
        { label: "Check" },
      ]}
      title="Relationship Check"
      description="Test whether a user has a specific relation on an object."
    >
      <Section>
        <Section.Header>Check Query</Section.Header>
        <Section.Content>
          <Grid cols={1} small={3} gap={12}>
            <Input
              label="User"
              placeholder="user:alice"
              value={user}
              onChange={(e) => setUser(e.target.value)}
              required
            />
            <Input
              label="Relation"
              placeholder="viewer"
              value={relation}
              onChange={(e) => setRelation(e.target.value)}
              required
            />
            <Input
              label="Object"
              placeholder="document:readme"
              value={object}
              onChange={(e) => setObject(e.target.value)}
              required
            />
          </Grid>
        </Section.Content>
        <Section.Content borderTop>
          <Button
            onClick={doCheck}
            disabled={loading || !user || !relation || !object}
          >
            {loading ? "Checking..." : "Check"}
          </Button>
        </Section.Content>
      </Section>

      {error && (
        <Message state="alert" header="Error">
          {error}
        </Message>
      )}

      {result !== null && (
        <Message
          state={result ? "success" : "warning"}
          header={result ? "Allowed" : "Not Allowed"}
        >
          {result
            ? `${user} has ${relation} on ${object}`
            : `${user} does NOT have ${relation} on ${object}`}
        </Message>
      )}
    </PageLayout>
  );
}
